import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconUndo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.39775 4.33525C6.61742 4.11558 6.61742 3.75942 6.39775 3.53975C6.17808 3.32008 5.82192 3.32008 5.60225 3.53975L2.97725 6.16475C2.86742 6.27459 2.8125 6.41854 2.8125 6.5625C2.8125 6.63877 2.82768 6.71149 2.85518 6.77782C2.88263 6.84416 2.92332 6.90632 2.97725 6.96025L5.60225 9.58525C5.82192 9.80492 6.17808 9.80492 6.39775 9.58525C6.61742 9.36558 6.61742 9.00942 6.39775 8.78975L4.733 7.125H11.25C12.8033 7.125 14.0625 8.3842 14.0625 9.9375C14.0625 11.4908 12.8034 12.75 11.2502 12.75H7.125C6.81434 12.75 6.5625 13.0018 6.5625 13.3125C6.5625 13.6232 6.81434 13.875 7.125 13.875H11.2502C13.4248 13.875 15.1875 12.1121 15.1875 9.9375C15.1875 7.76288 13.4246 6 11.25 6H4.733L6.39775 4.33525Z",
		fill: "#33373D"
	})
});
export { SvgIconUndo as ReactComponent };
